import { render, staticRenderFns } from "./Same.vue?vue&type=template&id=2726b2b4&scoped=true&"
import script from "./Same.vue?vue&type=script&lang=js&"
export * from "./Same.vue?vue&type=script&lang=js&"
import style0 from "./Same.vue?vue&type=style&index=0&id=2726b2b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2726b2b4",
  null
  
)

export default component.exports